// extracted by mini-css-extract-plugin
export default {"whatWeDoSection":"ConceptSection_whatWeDoSection__49q85","heading":"ConceptSection_heading__f45Ke","button_div":"ConceptSection_button_div__aCwLS"};